<div
  [id]="toastId"
  class="ccl-toast ccl-toast--{{ variant }} ccl-toast--{{ position }} ccl-toast--{{ animation }}"
  [class.ccl-toast--visible]="isVisible"
  [class.ccl-toast--exiting]="isExiting"
  [attr.role]="ariaAttributes['role']"
  [attr.aria-live]="ariaAttributes['aria-live']"
  [attr.aria-labelledby]="ariaAttributes['aria-labelledby']"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div class="ccl-toast__content">
    <span class="ccl-toast__icon" aria-hidden="true">{{ getDefaultIcon() }}</span>
    
    <div class="ccl-toast__text">
      @if (title) {
        <h4 [id]="toastId + '-title'" class="ccl-toast__title">{{ title }}</h4>
      }
      <span class="ccl-toast__message">{{ message }}</span>
    </div>
  </div>

  @if (dismissible) {
    <button
      class="ccl-toast__close"
      type="button"
      aria-label="Close notification"
      (click)="close()"
    >
      <span aria-hidden="true">✕</span>
    </button>
  }

  @if (showProgress && duration > 0) {
    <div class="ccl-toast__progress" aria-hidden="true">
      <div class="ccl-toast__progress-bar" [style.width.%]="progress"></div>
    </div>
  }
</div>
